export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      
      <div className="bg-white p-6 rounded-xl shadow-xl flex items-center gap-3">
        
        <div className="w-6 h-6 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        
        <span className="text-gray-700 font-medium">
          Loading...
        </span>

      </div>

    </div>
  );
}